import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  saveScreenshotsRequestRequest: ["payload"],
  saveScreenshotsRequestSuccess: ["payload"],
  saveScreenshotsRequestFailure: ["payload"],

  updateCommentRequestRequest: ["payload"],
  updateCommentRequestSuccess: ["payload"],
  updateCommentRequestFailure: ["payload"],

  deleteScreenshotsRequestRequest: ["payload"],
  deleteScreenshotsRequestSuccess: ["payload"],
  deleteScreenshotsRequestFailure: ["payload"],

  requestsSetProp: ["key", "value"],

  logout: null
})

export const RequestsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  saveFetching: false,
  saveResult: null,
  updateFetching: false,
  updateResult: null,
  deleteFetching: false,
  deleteResult: null,
  selectedRequest: null
})

export const selectRequestResult = (state) =>
  state.requests.saveResult || state.requests.updateResult || state.requests.deleteResult

/* ------------- Functions for reducer cases ------------- */

export const requestsSetProp = (state, { key, value }) => state.merge({ [key]: value })

const saveScreenshotsRequestRequest = (state) => state.merge({ saveFetching: true })
const saveScreenshotsRequestSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "add_screenshots" })
const saveScreenshotsRequestFailure = (state) => state.merge({ saveFetching: false })

const updateCommentRequestRequest = (state) => state.merge({ updateFetching: true })
const updateCommentRequestSuccess = (state, { payload: updateRequest }) =>
  state.merge({
    updateFetching: false,
    updateResult: "update_comment",
    selectedRequest: {
      ...state.selectedRequest,
      ...updateRequest
    }
  })
const updateCommentRequestFailure = (state) => state.merge({ updateFetching: false })

const deleteScreenshotsRequestRequest = (state) => state.merge({ deleteFetching: true })
const deleteScreenshotsRequestSuccess = (state) =>
  state.merge({ deleteFetching: false, deleteResult: "delete_screenshots" })
const deleteScreenshotsRequestFailure = (state) => state.merge({ deleteFetching: false })

const logout = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SAVE_SCREENSHOTS_REQUEST_REQUEST]: saveScreenshotsRequestRequest,
  [Types.SAVE_SCREENSHOTS_REQUEST_SUCCESS]: saveScreenshotsRequestSuccess,
  [Types.SAVE_SCREENSHOTS_REQUEST_FAILURE]: saveScreenshotsRequestFailure,

  [Types.UPDATE_COMMENT_REQUEST_REQUEST]: updateCommentRequestRequest,
  [Types.UPDATE_COMMENT_REQUEST_SUCCESS]: updateCommentRequestSuccess,
  [Types.UPDATE_COMMENT_REQUEST_FAILURE]: updateCommentRequestFailure,

  [Types.DELETE_SCREENSHOTS_REQUEST_REQUEST]: deleteScreenshotsRequestRequest,
  [Types.DELETE_SCREENSHOTS_REQUEST_SUCCESS]: deleteScreenshotsRequestSuccess,
  [Types.DELETE_SCREENSHOTS_REQUEST_FAILURE]: deleteScreenshotsRequestFailure,

  [Types.REQUESTS_SET_PROP]: requestsSetProp,

  [Types.LOGOUT]: logout
})
